import React from 'react'
import PropTypes from 'prop-types'
import { shadowAiAppRows, shadowAiUserRows } from '../../data/mockBackedAdapters'
import ComingSoonOverlay from '../../components/ComingSoonOverlay/ComingSoonOverlay'
import MockedPanel from '../../components/MockedPanel/MockedPanel'
import ReportTable from '../../components/ReportTable/ReportTable'
import SubArea from '../../components/SubArea/SubArea'
import ShadowAiUsers from './ShadowAiUsers'

const DISCOVER_KB_URL = 'https://kb.augmentt.com/kb/en/discover-374262'
const DISCOVER_ICON_SRC = '/media/icons/discover.svg'

// The "Discover not in use" card, reused over each table's blurred preview.
function DiscoverOverlay() {
  return (
    <ComingSoonOverlay
      iconSrc={DISCOVER_ICON_SRC}
      titleId="AI_RISK_REPORT.THIRD.SHADOW_AI.NOT_IN_USE_TITLE"
      bodyId="AI_RISK_REPORT.THIRD.SHADOW_AI.NOT_IN_USE_BODY"
      ctaId="AI_RISK_REPORT.THIRD.SHADOW_AI.NOT_IN_USE_CTA"
      ctaHref={DISCOVER_KB_URL}
    />
  )
}

// Shown when the organization does not own Discover: illustrative rows sit behind a subscription overlay.
export default function ShadowAiEmptyState({ columns, dataAvailability = [] }) {
  const rows = shadowAiAppRows.map((app) => ({ ...app, key: app.entityId || app.name }))

  return (
    <>
      <SubArea titleId="AI_RISK_REPORT.THIRD.SHADOW_AI.APPS_AREA_TITLE">
        <MockedPanel overlay={<DiscoverOverlay />}>
          <ReportTable columns={columns} rows={rows} />
        </MockedPanel>
      </SubArea>
      <SubArea
        titleId="AI_RISK_REPORT.THIRD.SHADOW_AI_USERS.TITLE"
        descriptionId="AI_RISK_REPORT.THIRD.SHADOW_AI_USERS.SUBTITLE"
      >
        <MockedPanel overlay={<DiscoverOverlay />}>
          <ShadowAiUsers usersData={shadowAiUserRows} dataAvailability={dataAvailability} />
        </MockedPanel>
      </SubArea>
    </>
  )
}

ShadowAiEmptyState.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  dataAvailability: PropTypes.arrayOf(PropTypes.shape({})),
}
